import _ from 'lodash';
import maestro from '../../../util/maestro/maestro.js';
import { navigationSteps } from '../navigation/navigationHelpers';
import contentProvider from '../../../redux/modules/contentProvider/contentProvider';
import * as myplanActions from '../pages/MyPlan/myplan/myplan';
import * as myplanReviewActions from '../pages/MyPlan/review/review';
import * as myplanConfirmationActions from '../pages/MyPlan/confirmation/confirmation';
import * as showOffersFilterActions from '../pages/MyPlan/showOffers/showOffersFilter';
import * as quickCheckoutReviewActions from '../pages/QuickCheckout/review/review';
import * as quickCheckoutConfirmationActions from '../pages/QuickCheckout/confirmation/confirmation';
import * as quickCheckoutRedirectActions from '../pages/QuickCheckout/redirect/redirect';
import * as moversLocalizationActions from '../pages/Movers/localization/localization';
import * as moversUnserviceableActions from '../pages/Movers/unserviceable/unserviceable';
import * as moversCancelActions from '../pages/Movers/cancel/cancel';
import * as moversSpecialistActions from '../pages/Movers/specialist/specialist';
import * as moversInstallActions from '../pages/Movers/install/install';
import * as moversReviewActions from '../pages/Movers/review/review';
import * as moversConfirmationActions from '../pages/Movers/confirmation/confirmation';
import * as accountMultipleAddressActions from '../pages/Account/multipleAddress/multipleAddress';

const config = {
  [navigationSteps.myPlan.MYPLAN]: {
    pageLoadActions: [myplanActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.myPlan.REVIEW]: {
    pageLoadActions: [myplanReviewActions.DL_PAGE_LOADED],
    pageLoadVars: state => {
      const isConsent = _.get(state, 'review.content.review.consentReview');

      return {
        page: {
          attributes: {
            pageLoadEvent: 'Order review'
          }
        },
        transaction: {
          attributes: {
            buyflowType: "CancelStreamingVideo",
            buyflowStep: "review",
            consentDecree: isConsent ? 'success' : 'failure'
          }
        }
      };
    }
  },
  [navigationSteps.myPlan.CONFIRMATION]: {
    pageLoadActions: [myplanConfirmationActions.DL_PAGE_LOADED],
    pageLoadVars: state => {
      const hasWorklist = _.get(state, 'confirmation.content.cartInfo.hasWorklist');

      return {
        page: {
          attributes: {
            pageLoadEvent: 'Purchase'
          }
        },
        transaction: {
          attributes: {
           buyflowType: "CancelStreamingVideo",
           buyflowStep: "order",
           installationType: "not required",
           fulfillmentType: hasWorklist ? "shop:order flow thru:soft" : "shop:order flow thru"
          }
        }
      };
    }
  },
  [navigationSteps.myPlan.OFFERS_FILTER]: {
    pageLoadActions: [showOffersFilterActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.myPlan.CONTACTUS]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.myPlan.MESSAGE]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.myPlan.ERROR]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.myPlan.OMNI_LANDING]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.LOCALIZATION]: {
    pageLoadActions: [moversLocalizationActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.UNSERVICEABLE]: {
    pageLoadActions: [moversUnserviceableActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.CANCEL]: {
    pageLoadActions: [moversCancelActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.SPECIALIST]: {
    pageLoadActions: [moversSpecialistActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.INSTALL]: {
    pageLoadActions: [moversInstallActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.REVIEW]: {
    pageLoadActions: [moversReviewActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.CONFIRMATION]: {
    pageLoadActions: [moversConfirmationActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.CONTACTUS]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.CANCELLATION_CONTACTUS]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.movers.ERROR]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.quickCheckout.REVIEW]: {
    pageLoadActions: [quickCheckoutReviewActions.DL_PAGE_LOADED],
    pageLoadVars: state => {
      const isConsent = _.get(state, 'review.content.review.consentReview');

      return {
        page: {
          attributes: {
            pageLoadEvent: 'Order review'
          }
        },
        transaction: {
          attributes: {
            buyflowType: "quick checkout",
            buyflowStep: "review",
            installationType: "not required",
            consentDecree: isConsent ? 'success' : 'failure'
          }
        }
      };
    }
  },
  [navigationSteps.quickCheckout.CONFIRMATION]: {
    pageLoadActions: [quickCheckoutConfirmationActions.DL_PAGE_LOADED],
    pageLoadVars: state => {
      const hasWorklist = _.get(state, 'confirmation.content.cartInfo.hasWorklist');

      return {
        page: {
          attributes: {
            pageLoadEvent: 'Purchase'
          }
        },
        transaction: {
          attributes: {
            buyflowType: "quick checkout",
            buyflowStep: "order",
            installationType: "not required",
            fulfillmentType: hasWorklist ? "shop:order flow thru:soft" : "shop:order flow thru"
          }
        }
      };
    }
  },
  [navigationSteps.quickCheckout.REDIRECT]: {
    pageLoadActions: [quickCheckoutRedirectActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.quickCheckout.ERROR]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.quickCheckout.CONTACTUS]: {
    pageLoadActions: [],
    pageLoadVars: () => {
      return {};
    }
  },
  [navigationSteps.account.MULTIPLE_ADDRESS]: {
    pageLoadActions: [accountMultipleAddressActions.DL_PAGE_LOADED],
    pageLoadVars: () => {
      return {};
    }
  },
};

export const roolz = state => {
  const data = {};

  const subCategoryLogic = {
    subCategory1: {
      "if" : [
        // MyPlan
        {"==": [{"var":"flow"}, "myPlan"] },
        "my plan",
        // Movers
        {"==": [{"var":"flow"}, "movers"] },
        "movers",
        // QuickCheckout
        {"==": [{"var":"flow"}, "quickCheckout"] },
        "checkout",
        // Account
        {"==": [{"var":"flow"}, "account"] },
        "account"
      ]
    }
  };

  return maestro.conduct(state, data, subCategoryLogic);
};

const basePageLoadVars = state => {
  const {isMoversFlow, subCategory1} = roolz(state);
  const userInfoFromClient = [
    {
      profile: [
        {
          profileInfo: {
            currentMRC: !isMoversFlow ? `${_.get(state, 'plan.totalAmount.prices[0].amount.dollars')}.${_.get(state, 'plan.totalAmount.prices[0].amount.cents')}` : undefined,
            hasEmail: typeof (_.get(state, 'customer.customer.emailAddress')) === "string" && _.get(state, 'customer.customer.emailAddress') !== "",
            recognizationType: 'cookie recognized',
            services: !isMoversFlow ? {
              LOB: {
                name: _.flatten(_.map(_.get(state, 'plan.servicePackages.packages'), (item) => item.lineOfBusinesses)),
                tier: _.flatten(_.map(_.get(state, 'plan.servicePackages.packages'), (item) => item.name))
              },
              productType: (() => {
                let lobCount = _.get(state, 'plan.servicePackages.packages[0].lineOfBusinesses.length');

                switch (lobCount) {
                  case 4: return "quad play";
                  case 3: return "triple play";
                  case 2: return "double play";
                  default: return _.get(state, 'plan.servicePackages.packages.length') > 1 ? "unbundled" : "single play";
                }
              })(),
              addOns: _.flatten(_.map(_.get(state, 'plan.channels'), (item) => item.name)),
              equipments: _.flatten(_.map(_.get(state, 'equipment.equipment'), (item) => item.name))
            } : undefined
          }
        }
      ],
      segment: {
        isLocalized: _.get(state, 'customer.loaded')
      }
    }
  ];

  return {
    schemaVersion: 0.1,
    page:{
      category: {
        primaryCategory: 'shop',
        subCategory1: subCategory1,
        businessType: 'resi',
        siteType: 'sales',
        designType: 'responsive'
      },
      pageInfo: {
        language: 'en'
      },
      attributes: {
        errorMessage: _.get(state, 'dataLayer.analyticsData.digitalData.page.errorMessages')
      },
      codebase: {
        name: 'df my plan',
        releaseVersion: '17.06.01'
      },
      affiliate: {
        name: 'comcast',
        channel: 'web'
      }
    },
    product: _.get(state, 'dataLayer.analyticsData.digitalData.page.product'),
    siteInfo: {
      sessionID: _.get(state, 'dataLayer.analyticsData.digitalData.page.siteInfo.sessionID'),
      visitorID: _.get(state, 'dataLayer.analyticsData.digitalData.page.siteInfo.visitorID'),
      ctpSessionID: _.get(state, 'dataLayer.analyticsData.digitalData.page.siteInfo.ctpSessionID')
    },
    transaction: _.get(state, 'dataLayer.analyticsData.digitalData.page.transaction'),
    user: _.map(_.merge(_.get(state, 'dataLayer.analyticsData.digitalData.page.user', []), userInfoFromClient))
  };
};

export const pageLoadActionsForRoute = (routeKey) => {
  return _.get(config, `${routeKey}.pageLoadActions`);
};

export const pageLoadVarsForRoute = (routeKey, state) => {
  const routePageLoadVarsSelector = _.get(config, `${routeKey}.pageLoadVars`);
  const routePageLoadVars = routePageLoadVarsSelector(state);
  const screenName = contentProvider.getValue(`${routeKey}.screenName`);

  const pageNameAtts = {
    page: {
      pageInfo: {
        screenName: screenName || ''
      }
    }
  };
  const pageLoadVars = _.merge({}, basePageLoadVars(state), pageNameAtts, routePageLoadVars);

  return pageLoadVars;
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/dataLayer/dataLayerHelpers.js
 **/